module.exports = __webpack_public_path__ + "static/thumbnail-309345443d872b224b880bdd9f31f24b.png";